export function typeMatches(currentType: string, matchedType: string): boolean {
  return (
    currentType === matchedType ||
    new RegExp(`_${matchedType}$`).test(currentType)
  )
}
